import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPilone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pilone, maintenance"><path d="M2.75 20.25H21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16 9.75H8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M6.75 14.25H17.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.82031 20L9.74888 2.75H14.2489L19.1775 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPilone;
